import { useTranslation } from 'react-i18next';
import type { ObserveLocationEquipmentRef } from '@apis/reports';
import { PanelCard } from '../../shared/PanelCard/PanelCard';
import { EquipmentRow } from './EquipmentRow';
import classes from './EquipmentPanel.module.css';

interface IEquipmentPanelProps {
  equipment: ObserveLocationEquipmentRef[];
  isLoading: boolean;
}

export function EquipmentPanel({ equipment, isLoading }: IEquipmentPanelProps) {
  const { t } = useTranslation();
  const title = t('reports.observeLocation.section.equipment');

  if (isLoading) {
    return (
      <PanelCard aria-busy="true" aria-label={title}>
        <h4 className={classes.title}>{title}</h4>
      </PanelCard>
    );
  }

  return (
    <PanelCard aria-label={title}>
      <h4 className={classes.title}>{title}</h4>
      {equipment.length === 0 ? (
        <div className={classes.empty}>{t('reports.observeLocation.empty.equipment')}</div>
      ) : (
        equipment.map((e) => <EquipmentRow key={e.equipmentId} equipment={e} />)
      )}
    </PanelCard>
  );
}
